const API_BASE_URL = process.env.REACT_APP_API_URL;
const STORAGE_KEY = "skillskulpt_user";

export async function apiFetch(path, options = {}) {
  if (!API_BASE_URL) {
    throw new Error("API base URL is not configured.");
  }

  let idToken;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : null;
    idToken = parsed?.idToken;
  } catch {
    idToken = undefined;
  }

  const headers = {
    ...(options.headers || {}),
    ...(idToken ? { Authorization: `Bearer ${idToken}` } : {}),
  };

  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers,
  });

  if (response.status === 401) {
    localStorage.removeItem(STORAGE_KEY);
    window.location.href = '/';
  }

  return response;
}

